@if (showAlertaExclusaoBeneficio === true) {
  <div class="body-alert-modal">
    <div class="div-alert" style="width: 509px;height: 273px">
      <div class="row" style="position: absolute;right: 40px;top: 15px;">
        <button class="btn-icon" (click)="cancelaExclusao()">
          <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
        </button>
      </div>
      <div style="margin-top: 50px;">
        <h1 class="titulo-alert-exclusao">Excluir benefício</h1>
        <p class="mensagem-alert-exclusao">Tem certeza que deseja excluir este benefício?</p>
      </div>
      <div style="margin-top: 40px;gap: 25px;display:flex;justify-content: center;">
        <div>
          <button class="botao-cancelar-exclusao" (click)="cancelaExclusao()" id="cancelaExclusao">CANCELAR</button>
        </div>
        <div>
          <button class="botao-confirmar-exclusao" (click)="confirmaExclusao()" id="confirmaExclusao">EXCLUIR</button>
        </div>
      </div>
    </div>
  </div>
}
